import React from 'react';
import { FaWallet, FaTimes, FaArrowRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './StyleCreditsReminder.css';

const StyleCreditsReminder = ({ 
  showReminder, 
  onClose, 
  potentialCredits, 
  subtotal,
  onLoginClick 
}) => {
  if (!showReminder) return null;

  const handleLoginClick = () => {
    if (onLoginClick) {
      onLoginClick();
    }
  };

  return (
    <div className="credits-reminder-banner">
      <div className="credits-reminder-content">
        <div className="credits-reminder-icon">
          <FaWallet />
        </div>
        
        <div className="credits-reminder-text">
          <h3>You're about to miss earning ₹{potentialCredits} Style Credits!</h3>
          <p>Log in now to earn 5% back on this order and save on your next purchase.</p>
        </div>
        
        <div className="credits-reminder-actions">
          {onLoginClick ? (
            <button 
              className="credits-login-btn"
              onClick={handleLoginClick}
            >
              <FaWallet />
              LOGIN TO EARN CREDITS
              <FaArrowRight />
            </button>
          ) : (
            <Link to="/login" className="credits-login-btn">
              <FaWallet />
              LOGIN TO EARN CREDITS
              <FaArrowRight />
            </Link>
          )}
          
          <button 
            className="credits-reminder-close"
            onClick={onClose}
            aria-label="Close reminder"
          >
            <FaTimes />
          </button>
        </div>
      </div>
    </div>
  );
};

export default StyleCreditsReminder;
